export default __webpack_public_path__ + "static/media/Hidden Blade.76e202b7.png";